import React from "react";

// Source
import StoreRoute from "../store/Route";
import * as HelperSrc from "../HelperSrc";
import * as ModelRoute from "../model/Route";

export default class ControllerAlert {
    // Variable
    private storeRoute: ModelRoute.Istore<ModelRoute.Idata>;
    private storageRouteData = React.useRef<ModelRoute.Idata | undefined>(undefined);

    private elementViewMain = React.useRef<HTMLElement | null>(null);

    private isRendered = React.useRef<boolean>(false);

    getStorageRoute: ModelRoute.Idata | undefined;

    // Method
    constructor(isRendered: boolean) {
        this.storeRoute = new StoreRoute();
        this.storageRouteData.current = this.storeRoute.storageGet();

        this.isRendered.current = isRendered;

        const [getStorageRoute] = React.useState<ModelRoute.Idata | undefined>(this.storageRouteData.current);
        this.getStorageRoute = getStorageRoute;
    }

    initializeHook = (): void => {
        React.useEffect(() => {
            HelperSrc.domObserver(".view_breadcrumb", () => {
                this.initializeHtmlElement();
            });
        }, []);

        React.useEffect(() => {
            this.storageRouteData.current = this.storeRoute.storageGet();
        }, [this.storageRouteData.current]);
    };

    clickHome = (): void => {
        if (this.storageRouteData.current) {
            HelperSrc.routerHistoryPush(this.storageRouteData.current.main.path);
        }
    };

    private initializeHtmlElement = (): void => {
        if (!this.elementViewMain.current) {
            this.elementViewMain.current = document.querySelector<HTMLElement>(".view_breadcrumb");
        }
    };
}
